
export default {
  'zh-CN': {
  },
  'en': {
  },
  'ja': {
  }
}
